import {
  faBriefcase,
  faCircleCheck,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Difference_Section.css";
import { useState } from "react";
import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";

const Difference_Section = () => {
  const learningFeatures = [
    "Interactive e-learning content",
    "Pre-recorded video lectures",
    "Digital self-learning materials",
    "E-books and online resources",
    "Interactive online sessions",
    "Discussion forums ",
    "Quizzes and self-assessments",
    "Assignments and academic support ",
  ];

  const careerFeatures = [
    "Critical and analytical thinking",
    "Research orientation",
    "Communication skills",
    "Digital and information literacy",
    "Leadership and teamwork",
    "Ethical and social responsibility",
    "Civic and global awareness",
    "Employability and professional readiness",
    "Lifelong learning orientation",
  ];

  const [modalshow, setmodalshow] = useState(false);
  const openModal = () => {
    setmodalshow(true);
    // setExpanded(false);
  };

  return (
    <section className="difference_section">
      <div className="container">
        <div className="difference_heading">
          <span className="sub_title">
            India's Only Comfort Learning Platform
          </span>

          <h2>
            Why Students Choose
            <span> Dr. D. Y. Patil Online</span>
          </h2>

          <p>
            Experience a smarter way of learning with industry-focused
            education, flexible schedules, and career-oriented outcomes.
          </p>
        </div>

        <div className="difference_cards">
          <div className="difference_card">
            <div className="card_top">
              <div className="icon_box">
                <FontAwesomeIcon icon={faGraduationCap} />
              </div>

              <h3>Interactive E-Learning Experience</h3>
            </div>

            <ul>
              {learningFeatures.map((item, index) => (
                <li key={index}>
                  <FontAwesomeIcon icon={faCircleCheck} />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Career Card */}
          <div className="difference_card">
            <div className="card_top">
              <div className="icon_box">
                <FontAwesomeIcon icon={faBriefcase} />
              </div>

              <h3>Career Growth Opportunities</h3>
            </div>

            <ul>
              {careerFeatures.map((item, index) => (
                <li key={index}>
                  <FontAwesomeIcon icon={faCircleCheck} />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <button onClick={openModal} className="apply_btn">
          Talk to Counsellor
        </button>
      </div>

      {/* Modal */}
      <InquiryFormModal
        show={modalshow}
        onHide={() => {
          setmodalshow(false);
          // setExpanded(false);
        }}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </section>
  );
};

export default Difference_Section;
